import { Baby, BadgePercentIcon, Beef, BrushCleaning, CakeSlice, Candy, Cherry, Dog, Ham, House, Martini, Milk, SprayCan, Store, ThermometerSnowflake, Trash } from "lucide-react"


interface AppSubMenu{
    id:number
    name:string
    slug: string
    icon:string
}

interface AppMenuOptions{
    id:number
    name:string
    slug:string
    color: string 
    icon: string 
    layout:string
    url:string
    sub_menu: AppSubMenu[]
}

const MenuIcon:React.FC<{iconName:string, size:number, className:string}> = ({iconName,size, className}) => {

    switch(iconName){
        case 'store':
            return (
                <Store size={size} className={className}/>
            );
        case 'milk':
            return (
                <Milk size={size} className={className}/>
            );
        case 'fruit':
            return (
                <Cherry size={size} className={className}/>
            );
        case 'beef':
            return (
                <Beef size={size} className={className}/>
            );     
        case 'baby':
            return (
                <Baby size={size} className={className}/>
            ); 
        case 'home':
            return (
                <House size={size} className={className}/>
            );
        case 'house':
            return (
                <Dog size={size} className={className}/>
            );
        case 'clean':
                return (
                    <BrushCleaning size={size} className={className}/>
                );            
        case 'drink':
            return (
                <Martini size={size} className={className}/>
            );  
        case 'persCare':
            return (
                <SprayCan size={size} className={className}/>
            ); 
        case 'bread':
            return (
                <CakeSlice size={size} className={className}/>
            );        
        case 'candy':
            return (
                <Candy size={size} className={className}/>
            );  
        case 'cheese':
            return (
                <Ham size={size} className={className}/>
            );    
        case 'frozen':
            return (
                <ThermometerSnowflake size={size} className={className}/>
            ); 
        case 'sale':
            return (
                <BadgePercentIcon size={size} className={className}/>
            );                                   
        default:
            return null;
    }
}

export type {AppSubMenu,AppMenuOptions}

export default MenuIcon;
